import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { DayCampPageOptions } from "../Constants/RegistrationPageOptions";
// import EventCardList from "./EventCardList";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../Components/CheckoutForm";
import DateHelpers from "../Helper/DateHelpers";
import DataAccessHelper from "../Helper/DataAccessHelper";
import '../Styles/DayCampPaymentSuccess.scss';

function DayCampPaymentSuccess() {

   console.log("Hi!")
   const location = useLocation();
   const navigate = useNavigate();
   const { paymentAmount, promoCode } = location.state || {};
   const isFreecamp = promoCode?.isSelected && promoCode?.discountPercent === 100;
      console.log("paymentAmount", paymentAmount)

   return(
      <div className="DayCampPaymentSuccessContainer">
         <div className="DayCampPaymentSuccessContent">
            { isFreecamp &&
               <div>
                  <div className="DayCampPaymentSuccessHeading">
                     Registration Successful!
                  </div>
                  <div className="DayCampPaymentSuccessAmount">
                     Your promo code covered the full cost of camp. No payment was required.
                  </div>
               </div>
            }
            { !isFreecamp && paymentAmount == 0 &&
               <div className="DayCampPaymentSuccessHeading">
                  Registration Successful!
               </div>
            }
            { !isFreecamp && paymentAmount > 0 &&
            <div>
               <div className="DayCampPaymentSuccessHeading">
               Thank You For Your Payment!
               </div>
               <div className="DayCampPaymentSuccessAmount">
               Amount: ${Number(paymentAmount).toFixed(2)}
               </div>
            </div>
            }
            <div className="DayCampPaymentSuccessRedirectButton">
               <button onClick={() =>  navigate('/groupaccount')}>
                  Return to Dashboard
               </button>
            </div>
         </div>
      </div>
   )
}
export default DayCampPaymentSuccess
